// extracted by mini-css-extract-plugin
export default {"archiveplayer":"ArchivePlayer_archiveplayer__WnewC","progress":"ArchivePlayer_progress__b91X1"};